import React from 'react';
import ReactDOM from 'react-dom';
import Application from './component/application';

ReactDOM.render(
  <Application />,
  document.getElementById('root')
);
